"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.reflect.construct");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/objectWithoutProperties.js"));
var _classCallCheck2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));
var _getPrototypeOf2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));
var _inherits2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _serviceBase = _interopRequireDefault(require("@/services/service-base"));
var _qs = _interopRequireDefault(require("qs"));
var _excluded = ["id"],
  _excluded2 = ["id"],
  _excluded3 = ["id"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var domain = process.env.VUE_APP_BASE_API_LOGIN;
var domain_2 = process.env.VUE_APP_BASE_API_ADMIN;
var RoleService = /*#__PURE__*/function (_Service) {
  function RoleService() {
    (0, _classCallCheck2.default)(this, RoleService);
    return _callSuper(this, RoleService, arguments);
  }
  (0, _inherits2.default)(RoleService, _Service);
  return (0, _createClass2.default)(RoleService, [{
    key: "getList",
    value: function getList(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.get("".concat(domain, "/v2/groups?").concat(_qs.default.stringify(param)));
    }
  }, {
    key: "add",
    value: function add(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.post('/v2/group/add', param);
    }
  }, {
    key: "getInfo",
    value: function getInfo(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.get("/v2/group/edit/".concat(param.id, "?pid=").concat(param.pid));
    }
  }, {
    key: "detail",
    value: function detail(param) {
      param.pid = process.env.VUE_APP_PID;
      var id = param.id,
        other = (0, _objectWithoutProperties2.default)(param, _excluded);
      return this.http.get("/v2/group/".concat(id, "/details?").concat(_qs.default.stringify(other)));
    }
  }, {
    key: "getNames",
    value: function getNames(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.get("/v2/group/list?".concat(_qs.default.stringify(param)));
    }
  }, {
    key: "getGroupEmployee",
    value: function getGroupEmployee(param) {
      param.pid = process.env.VUE_APP_PID;
      var id = param.id,
        other = (0, _objectWithoutProperties2.default)(param, _excluded2);
      return this.http.get("/v2/group/".concat(id, "/users?").concat(_qs.default.stringify(other)));
    }
  }, {
    key: "edit",
    value: function edit(param) {
      param.pid = process.env.VUE_APP_PID;
      var id = param.id,
        other = (0, _objectWithoutProperties2.default)(param, _excluded3);
      return this.http.post("/v2/group/edit/".concat(id), other);
    }
  }, {
    key: "del",
    value: function del(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.post("/v2/group/del/".concat(param.id));
    }

    // 用户下载管理
  }, {
    key: "getDownList",
    value: function getDownList(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.get("".concat(domain_2, "/api/download/index?").concat(_qs.default.stringify(param)));
    }
    // 下载excel表格
  }, {
    key: "downExcel",
    value: function downExcel(url) {
      var pid = process.env.VUE_APP_PID;
      return this.http.get("".concat(domain_2, "/api/download/download/?").concat(url, "&pid=").concat(pid));
    }
  }]);
}(_serviceBase.default);
var _default = exports.default = new RoleService({
  baseURL: process.env.VUE_APP_BASE_API_LOGIN
});